// 後端 API 錯誤 envelope 的 message / code 常數。
//
// 這些常數原本定義在 `api/commom.js`，但 `utils/errorObjectChecker.js` 需要它們，
// 而 `api/commom.js` 又需要 errorObjectChecker 的 predicate 來決定導轉 —— 會形成循環相依。
// 拆到 config 層讓兩邊都單向 import。
export const ERROR_MESSAGES = {
    ROLE_AUTHORITIES_FAILED: 'Role Authorities Failed',
    // fever-api 的 not found 慣例：httpStatus 是 400，真正的 404 放在 message
    NOT_FOUND: '404',
    PROMOTION_PERMISSION_DENIED: 'Permission denied',
    OTP_VALIDATION_FAILED: 'Validate OTP fail.',
    TOKEN_REQUIRED: 'token is required'
};

export const ERROR_CODES = {
    PERMISSION_DENIED: 'RLA-AU0-F0',
    PROMOTION_PERMISSION_DENIED: 'PMIVLD-AU0-F0',
    // promotion-tool 角色權限驗證失敗（message 同為 "Permission denied"）
    ROLE_VALIDATION_FAILED: 'ROLE-V0-F0',
    AUTHORIZATION_FAILED: 'LAI-AU0-F0',
    // 這個 sponsorId 在資料庫查無資料（不是權限問題）
    SPONSOR_NOT_EXIST: 'SP-R1-FNF1'
};
